import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-20a7f93e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-season-selector" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select" }, "Select Season", -1))
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "No Season Selected", -1))
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loadingSeasons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "loading seasons..."))
      : _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.model) = $event)),
          disabled: $props.disabled
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.seasonsArray, (seasonOption, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: seasonOption.$id
            }, [
              _createTextVNode(_toDisplayString(seasonOption.name), 1),
              (seasonOption.isCurrent)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("(Current)")
                  ], 64))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6))
          }), 128))
        ], 8, _hoisted_4)), [
          [_vModelSelect, $setup.model]
        ])
  ]))
}